export enum DeviceKind {
    Microphone = 'audioinput',
    Speaker = 'audiooutput',
    Camera = 'videoinput'
}